import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Row, Card, CardBody } from 'reactstrap';
import axios from 'axios';
import { isEmpty } from '@/shared/helpers';
import { getAllPrograms } from '@/shared/apiHelper.jsx';
import CoCardReportDataTable from '../../Program/View/Reports/CoCardReport/components/CoCardReportDataTable';

const CoCardReport = () => {
  const [defaultPrograms, setDefaultPrograms] = useState([]);
  const [wait, setWait] = useState(false);

  useEffect(() => {
    setWait(true);
    axios.get('/config')
      .then(res => {
        const cocardProgramId = res.data?.COCARD_PROGRAM_ID;
        if (!cocardProgramId) {
          setWait(false);
          return;
        }
        return getAllPrograms(`minimal=true&limit=99999999&programId=${cocardProgramId}`);
      })
      .then(response => {
        if (!response) return;
        const data = response?.data || [];
        setDefaultPrograms(data.map(x => x.account_holder_id));
      })
      .catch(err => console.error('Failed to load CoCard programs:', err))
      .finally(() => setWait(false));
  }, []);

  if (isEmpty(defaultPrograms) || wait) {
    return <p>Loading...</p>;
  }

  return (
    <Container className="dashboard">
      <Row>
        <Col md={12}>
          <h3 className="page-title">CoCard Report</h3>
          <h3 className="page-subhead subhead">
            <Link to="/">Home</Link> / CoCard Report
          </h3>
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <Card>
            <CardBody>
              <CoCardReportDataTable programs={defaultPrograms} />
            </CardBody>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default CoCardReport;
